import { isLeapYear } from '@/utils/isLeapYear';

const NUM_DAYS_IN_MONTHS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function getMonthDayCountArray(year: number) {
  const numDaysCopy = [...NUM_DAYS_IN_MONTHS];
  if (!isLeapYear(year))
    return numDaysCopy;
  numDaysCopy[1] = 29;
  return numDaysCopy;
}

export function isValidSharpCharts2DateString(dateString: string) {
  if (typeof dateString !== 'string') { // TODO: just for the code that still uses this function, we'll keep this in regardless of the TypeScript conversion
    return false;
  }

  if (!dateString) {
    return true;
  }

  if (!/^(?:[0-9]{4})-(?:[0-9]{2})-(?:[0-9]{2})$/.test(dateString)) { // test for format: 'YYYY-MM-DD'
    return false;
  }

  const dateParts = dateString.split('-');
  const [year, month, day] = dateParts.map(Number);

  const numDaysInMonths = getMonthDayCountArray(year);
  const numDaysInMonth = numDaysInMonths[month - 1];

  const isValidYear = year >= 0;
  const isValidMonth = month >= 1 && month <= 12;
  const isValidDay = day >= 1 && day <= numDaysInMonth;

  return isValidYear && isValidMonth && isValidDay;
}
